import { render, staticRenderFns } from "./history-map.vue?vue&type=template&id=f1635d96"
import script from "./history-map.vue?vue&type=script&lang=js"
export * from "./history-map.vue?vue&type=script&lang=js"
import style0 from "./history-map.vue?vue&type=style&index=0&id=f1635d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports